<script setup>
import { ref, onMounted, onUnmounted } from "vue";
import { DbIcon } from "@db-ui/v-elements-enterprise/dist/components";

const props = defineProps({
  color: {
    default: "#000",
  },
});

const iconSize = ref("15rem");

onMounted(() => {
  updateIconSize();
  window.addEventListener("resize", updateIconSize);
});

const updateIconSize = () => {
  if (window.innerWidth <= 576) {
    iconSize.value = "2.5rem";
  } else {
    iconSize.value = "2.5rem";
  }
};

onUnmounted(() => {
  window.removeEventListener("resize", updateIconSize);
});
</script>

<template>
  <db-icon
    id="calendar"
    icon="calendar"
    variant="32-outline"
    :style="{
      '--icon-font-size': iconSize,
      '--icon-font-weight': 400,
      color: color,
    }"
    class="hydrated"
  ></db-icon>
</template>
